const Conf={
  apiUrl:process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL : "https://presentations-api.gmea.net/",
  filesUrl:process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL+"files/" : "https://presentations-api.gmea.net/files/",
}
export default Conf;
